function toggle_password() {
    var show_password = document.getElementById('show_password');
    var password_input = document.getElementById('user_password');
    if (!show_password || !password_input) {
        return;
    }
    if (show_password.checked) {
        password_input.type = "text";
    } else {
        password_input.type = "password";
    }
}

var showPassword = document.getElementById('show_password');
if (showPassword && document.getElementById('user_password')) {
    showPassword.addEventListener('click', toggle_password);
}
